<div class="overview-container">
  <!-- TOP HEADER SECTION -->

@if(loggedInUser){
<app-admin-dashboard [project]="'V-RETAIL'">

</app-admin-dashboard>
}

@if(!loggedInUser){
  <!-- SALES LEADS DASHBOARD -->
<app-sales-dashboard
  [project]="'V-RETAIL'">
</app-sales-dashboard>
}

</div>
